import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import Dashboard from './views/dashboard/Dashboard';
import AuthPage from './views/AuthPage';
import TerminalView from './views/TerminalView';
import { AuthProvider, useAuth } from './context/AuthContext';
import { handleBackendRoute } from './utils/backendRoutes';
import { ToastContainer } from 'react-toastify';
import { useEffect, useState } from 'react';
import { ToastContainerConfig } from './utils/toastConfig';
import { getAccountInfo } from './services/api';
import 'react-toastify/dist/ReactToastify.css';
import './styles/notifications.css';
import './styles/variables.css';
import './styles/neumorphic.css';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || '');

if (handleBackendRoute(window.location.pathname)) {
  throw new Error('Redirecting to backend...');
}

const AppRoutes = () => {
  const { token, checkLoginStatus, updateUserFromResponse } = useAuth();
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    const initializeApp = async () => {
      try {
        const isLoggedIn = await checkLoginStatus();
        if (token && isLoggedIn) {
          const accountInfo = await getAccountInfo();
          if (accountInfo.success) {
            updateUserFromResponse(accountInfo);
          }
        }
      } catch (error) {
        console.error('❌ Error in initialization:', error);
      } finally {
        setIsInitialized(true);
      }
    };
    initializeApp();
  }, [token]);

  if (token && !isInitialized) {
    return (
      <div className="app-loading">
        <div className="spinner"></div><p>Loading...</p>
      </div>
    );
  }

  return (
    <Routes>
      <Route path="/auth/login" element={token ? <Navigate to="/dashboard" replace /> : <AuthPage />} />
      {/* We route /auth/dashboard to /dashboard for cleaner URLs, but either works! */}
      <Route path="/auth/dashboard" element={token ? <Navigate to="/dashboard" replace /> : <AuthPage />} />
      <Route path="/dashboard" element={token ? <Dashboard /> : <Navigate to="/auth/login" replace />} />
      <Route path="/dashboard/audit" element={token ? <TerminalView /> : <Navigate to="/auth/login" replace />} />
      <Route path="/" element={<Navigate to="/auth/login" replace />} />
    </Routes>
  );
};

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Elements stripe={stripePromise}>
          <AppRoutes />
          <ToastContainer {...ToastContainerConfig} />
        </Elements>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;